import { cn } from "@/lib/utils"
import { IconLoader2 } from "@tabler/icons-react"
import { AlertCircle, CheckCircle, FileText } from "lucide-react"
import type { ImportRow } from "./useDeclarationImport"

/** One row per file with its own outcome; shared by the import page and the
 *  overview's inline import card so both read the same way. */
export function ImportRowList({
  rows,
  className,
}: {
  rows: ImportRow[]
  className?: string
}) {
  return (
    <ul
      className={cn("flex min-h-0 flex-col gap-1 overflow-y-auto", className)}
    >
      {rows.map((row) => (
        <li
          key={row.key}
          className="flex items-start gap-3 rounded-lg border border-grey4 bg-grey3 px-3 py-2.5"
        >
          <span className="mt-[2px] shrink-0">
            {row.state === "done" ? (
              <CheckCircle size={15} className="text-success" />
            ) : row.state === "failed" ? (
              <AlertCircle size={15} className="text-red1" />
            ) : row.state === "uploading" ? (
              <IconLoader2 size={15} className="animate-spin text-yellow1" />
            ) : (
              <FileText size={15} className="text-grey5" />
            )}
          </span>
          <span className="flex min-w-0 flex-col gap-0.5">
            <span className="truncate text-[13px] text-white">{row.name}</span>
            {row.error && (
              <span className="text-[12px] text-red1">{row.error}</span>
            )}
          </span>
        </li>
      ))}
    </ul>
  )
}
